angular.module("ainapp")
    .controller("AddFlatController", ["app.config", "$scope", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
        function (config, $scope, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Add Flat";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.Buildings = [];
            MainService.BuildingInDropdown().then(function (response) {
                $scope.Buildings = response.data;
            });

            $scope.Particulars = [];
            MainService.ParticularsInDropdown().then(function (response) {
                $scope.Particulars = response.data;
            });

            $scope.VATs = [];
            MainService.VATsInDropdown().then(function (response) {
                $scope.VATs = response.data;
            });

            $scope.FlatTypes = [];
            MainService.FlatTypesInDropdown().then(function (response) {
                $scope.FlatTypes = response.data;
            });


            MainService.GetCompanyProfile().then(function (response) {
                $scope.CompanyProfile = response.data;

                $scope.CountryCosts = [];
                MainService.CostCenterSubList($scope.CompanyProfile.CostCenterCountryId).then(function (response) {
                    $scope.CountryCosts = response.data;
                });

                $scope.StateCosts = [];
                MainService.CostCenterSubList($scope.CompanyProfile.CostCenterStateId).then(function (response) {
                    $scope.StateCosts = response.data;
                });

                $scope.TaxCategoryCosts = [];
                MainService.CostCenterSubList($scope.CompanyProfile.CostCenterTaxCategoryId).then(function (response) {
                    $scope.TaxCategoryCosts = response.data;
                });

                $scope.VatAccTypeCosts = [];
                MainService.CostCenterSubList($scope.CompanyProfile.CostCenterVatAccountTypeId).then(function (response) {
                    $scope.VatAccTypeCosts = response.data;
                });
            })

            $scope.setbuilding = function () {
                if (!$scope.Flat.Id > 0) {
                    angular.forEach($scope.Buildings, function (e) {
                        if (e.Id == $scope.Flat.BuildingId) {
                            $scope.Flat.Notes = e.Notes;
                            $scope.Flat.Conditions = e.Conditions;
                            $scope.Flat.RentalIncomeAccountId = e.RentalIncomeAccountId;
                            $scope.Flat.RentalIncomeAccount = e.RentalIncomeAccount;
                            $scope.Flat.RentReceivableAccountId = e.RentReceivableAccountId;
                            $scope.Flat.RentReceivableAccount = e.RentReceivableAccount;
                            $scope.Flat.PenaltyAccountId = e.PenaltyAccountId;
                            $scope.Flat.PenaltyAccount = e.PenaltyAccount;
                            $scope.Flat.AdvanceRentAccountId = e.AdvanceRentAccountId;
                            $scope.Flat.AdvanceRentAccount = e.AdvanceRentAccount;
                            $scope.Flat.BankAccountId = e.BankAccountId;
                            $scope.Flat.BankAccount = e.BankAccount;
                            $scope.Flat.BankLoanAccountId = e.BankLoanAccountId;
                            $scope.Flat.BankLoanAccount = e.BankLoanAccount;
                            $scope.Flat.ProvisionAccountId = e.ProvisionAccountId;
                            $scope.Flat.ProvisionAccount = e.ProvisionAccount;
                            $scope.Flat.RentalAdvanceReceivableAccountId = e.RentalAdvanceReceivableAccountId;
                            $scope.Flat.RentalAdvanceReceivableAccount = e.RentalAdvanceReceivableAccount;
                            $scope.Flat.RentalAdvanceReceivableCloseAccountId = e.RentalAdvanceReceivableCloseAccountId;
                            $scope.Flat.RentalAdvanceReceivableCloseAccount = e.RentalAdvanceReceivableCloseAccount;
                            $scope.Flat.ParkingIncomeAccountId = e.ParkingIncomeAccountId;
                            $scope.Flat.ParkingIncomeAccount = e.ParkingIncomeAccount;
                            $scope.Flat.ParkingAdvanceAccountId = e.ParkingAdvanceAccountId;
                            $scope.Flat.ParkingAdvanceAccount = e.ParkingAdvanceAccount;
                            $scope.Flat.LandloardCommissionAccountId = e.LandloardCommissionAccountId;
                            $scope.Flat.LandloardCommissionAccount = e.LandloardCommissionAccount;

                             
                            $scope.Flat.RevRentalIncomeAccountId = e.RevRentalIncomeAccountId;
                            $scope.Flat.RevRentalIncomeAccount = e.RevRentalIncomeAccount;
                            $scope.Flat.RevRentReceivableAccountId = e.RevRentReceivableAccountId;
                            $scope.Flat.RevRentReceivableAccount = e.RevRentReceivableAccount;
                            $scope.Flat.RevPenaltyAccountId = e.RevPenaltyAccountId;
                            $scope.Flat.RevPenaltyAccount = e.RevPenaltyAccount;
                            $scope.Flat.RevAdvanceRentAccountId = e.RevAdvanceRentAccountId;
                            $scope.Flat.RevAdvanceRentAccount = e.RevAdvanceRentAccount;
                            $scope.Flat.RevBankAccountId = e.RevBankAccountId;
                            $scope.Flat.RevBankAccount = e.RevBankAccount;
                            $scope.Flat.RevBankLoanAccountId = e.RevBankLoanAccountId;
                            $scope.Flat.RevBankLoanAccount = e.RevBankLoanAccount;
                            $scope.Flat.RevProvisionAccountId = e.RevProvisionAccountId;
                            $scope.Flat.RevProvisionAccount = e.RevProvisionAccount;
                            $scope.Flat.RevRentalAdvanceReceivableAccountId = e.RevRentalAdvanceReceivableAccountId;
                            $scope.Flat.RevRentalAdvanceReceivableAccount = e.RevRentalAdvanceReceivableAccount;
                            $scope.Flat.RevRentalAdvanceReceivableCloseAccountId = e.RevRentalAdvanceReceivableCloseAccountId;
                            $scope.Flat.RevRentalAdvanceReceivableCloseAccount = e.RevRentalAdvanceReceivableCloseAccount;
                            $scope.Flat.RevParkingIncomeAccountId = e.RevParkingIncomeAccountId;
                            $scope.Flat.RevParkingIncomeAccount = e.RevParkingIncomeAccount;
                            $scope.Flat.RevParkingAdvanceAccountId = e.RevParkingAdvanceAccountId;
                            $scope.Flat.RevParkingAdvanceAccount = e.RevParkingAdvanceAccount;
                            $scope.Flat.RevLandloardCommissionAccountId = e.RevLandloardCommissionAccountId;
                            $scope.Flat.RevLandloardCommissionAccount = e.RevLandloardCommissionAccount;

                            $scope.Flat.RentalPDCAccountId = e.RentalPDCAccountId;
                            $scope.Flat.RentalPDCAccount = e.RentalPDCAccount;
                            $scope.Flat.RentalBankAccountId = e.RentalBankAccountId;
                            $scope.Flat.RentalBankAccount = e.RentalBankAccount;
                            $scope.Flat.VATAccountId = e.VATAccountId;
                            $scope.Flat.VATAccount = e.VATAccount;

                            $scope.Flat.RevRentalPDCAccountId = e.RevRentalPDCAccountId;
                            $scope.Flat.RevRentalPDCAccount = e.RevRentalPDCAccount;
                            $scope.Flat.RevRentalBankAccountId = e.RevRentalBankAccountId;
                            $scope.Flat.RevRentalBankAccount = e.RevRentalBankAccount;
                            $scope.Flat.RevVATAccountId = e.RevVATAccountId;
                            $scope.Flat.RevVATAccount = e.RevVATAccount;


                            $scope.Flat.CostCenterCountryId = e.CostCenterCountryId;
                            $scope.Flat.CostCenterStateId = e.CostCenterStateId;
                            $scope.Flat.CostCenterTaxCategoryId = e.CostCenterTaxCategoryId;
                            $scope.Flat.CostCenterVatAccountTypeId = e.CostCenterVatAccountTypeId;
                        }
                    })
                }
            }


            $scope.LoadData = function (_selectedReceipt) {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.FlatById($stateParams.FlatId).then(function (response) {
                    $scope.Flat = response.data;
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error($scope.NetworkErrorLan);
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                })

            };

            $scope.init = function () {

                $scope.basePath = config.basePath;
                $scope.Load = false;
                $scope.Error = 0;

                $scope.Flat = {
                    FlatNo: "",
                    FloorNo: "",
                    Area: 0,
                    AvgRate: 0,
                    BedRooms: 0,
                    BathRooms: 0,
                    BuildingId: "",
                    FlatTypeId: "",
                    ContractType: "",
                    Photo: "",
                    Title: "",
                    ArabicTitle: "",
                    RemarksAr: "",
                    RentalIncomeAccountId: "",
                    RentReceivableAccountId: "",
                    PenaltyAccountId: "",
                    AdvanceRentAccountId: "",
                    BankAccountId: "",
                    BankLoanAccountId: "",
                    ProvisionAccountId: "",
                    RentalAdvanceReceivableAccountId: "",
                    RentalAdvanceReceivableCloseAccountId: "",
                    ParkingIncomeAccountId: "",
                    ParkingAdvanceAccountId: "",
                    LandloardCommissionAccountId: "",
                }
                $scope.ViewVal = 0;

                if ($stateParams.FlatId > 0) {
                    $scope.LoadData();
                }
            }
            $scope.init();



            $scope.DeleteFlat = function () {
                $('#deleteModal').modal('show');
                $scope.working = true;
            }

            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteFlat($scope.Flat.Id).then(function (response) {
                    if (response) {
                        $scope.Load = false;
                        toastr.success("Success");
                        $scope.working = true;
                        $('#deleteModal').modal('hide');
                        $scope.init();
                    }
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("Network Error");
                    $scope.working = false;
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                })

            }

            $scope.AccountAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        MainService.accountInAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error($scope.NetworkErrorLan);
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.RentIncomeAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Flat.RentalIncomeAccount = account;
                    $scope.Flat.RentalIncomeAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.RentReceivableAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Flat.RentReceivableAccount = account;
                    $scope.Flat.RentReceivableAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.PenaltyAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Flat.PenaltyAccount = account;
                    $scope.Flat.PenaltyAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.AdvanceRentAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Flat.AdvanceRentAccount = account;
                    $scope.Flat.AdvanceRentAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.BankAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Flat.BankAccount = account;
                    $scope.Flat.BankAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.BankLoanAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Flat.BankLoanAccount = account;
                    $scope.Flat.BankLoanAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.ProvisionAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Flat.ProvisionAccount = account;
                    $scope.Flat.ProvisionAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.RentalAdvanceReceivableAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Flat.RentalAdvanceReceivableAccount = account;
                    $scope.Flat.RentalAdvanceReceivableAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.RentalAdvanceReceivableCloseAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Flat.RentalAdvanceReceivableCloseAccount = account;
                    $scope.Flat.RentalAdvanceReceivableCloseAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.ParkingIncomeAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Flat.ParkingIncomeAccount = account;
                    $scope.Flat.ParkingIncomeAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.ParkingAdvanceAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: $scope.SearchByAccountLan,
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Flat.ParkingAdvanceAccount = account;
                    $scope.Flat.ParkingAdvanceAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.LandloardCommissionAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Flat.LandloardCommissionAccount = account;
                    $scope.Flat.LandloardCommissionAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };

              $scope.RevRentIncomeAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Flat.RevRentalIncomeAccount = account;
                    $scope.Flat.RevRentalIncomeAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.RevRentReceivableAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Flat.RevRentReceivableAccount = account;
                    $scope.Flat.RevRentReceivableAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.RevPenaltyAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Flat.RevPenaltyAccount = account;
                    $scope.Flat.RevPenaltyAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.RevAdvanceRentAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Flat.RevAdvanceRentAccount = account;
                    $scope.Flat.RevAdvanceRentAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.RevBankAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Flat.RevBankAccount = account;
                    $scope.Flat.RevBankAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.RevBankLoanAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Flat.RevBankLoanAccount = account;
                    $scope.Flat.RevBankLoanAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.RevProvisionAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Flat.RevProvisionAccount = account;
                    $scope.Flat.RevProvisionAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.RevRentalAdvanceReceivableAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Flat.RevRentalAdvanceReceivableAccount = account;
                    $scope.Flat.RevRentalAdvanceReceivableAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.RevRentalAdvanceReceivableCloseAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Flat.RevRentalAdvanceReceivableCloseAccount = account;
                    $scope.Flat.RevRentalAdvanceReceivableCloseAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.RevParkingIncomeAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Flat.RevParkingIncomeAccount = account;
                    $scope.Flat.RevParkingIncomeAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.RevParkingAdvanceAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: $scope.SearchByAccountLan,
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Flat.RevParkingAdvanceAccount = account;
                    $scope.Flat.RevParkingAdvanceAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };
            $scope.RevLandloardCommissionAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Flat.RevLandloardCommissionAccount = account;
                    $scope.Flat.RevLandloardCommissionAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };


            $scope.RentalPDCAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Flat.RentalPDCAccount = account;
                    $scope.Flat.RentalPDCAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };


            $scope.RentalBankAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Flat.RentalBankAccount = account;
                    $scope.Flat.RentalBankAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };


            $scope.VATAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Flat.VATAccount = account;
                    $scope.Flat.VATAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };


            $scope.RevRentalPDCAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Flat.RevRentalPDCAccount = account;
                    $scope.Flat.RevRentalPDCAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };


            $scope.RevRentalBankAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Flat.RevRentalBankAccount = account;
                    $scope.Flat.RevRentalBankAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };


            $scope.RevVATAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.Flat.RevVATAccount = account;
                    $scope.Flat.RevVATAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };


            $scope.BPCreditAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                minLength: 2,
                select: function (data) {
                    var account = this.dataItem(data.item.index());
                    $scope.BParticulars.CreditAccount = account;
                    $scope.BParticulars.CreditAccountId = account.Id;
                    $scope.$apply();
                },
                dataSource: $scope.AccountAutocompleteDataSource
            };


            $scope.AddData = function () {
                $scope.Error = 0;
                if ($scope.Flat.FlatNo == "") {
                    toastr.warning("Enter Flat No");
                } else if ($scope.Flat.BuildingId == "") {
                    toastr.warning("Select Building");
                } else if ($scope.Flat.FloorNo == "") {
                    toastr.warning("Enter Floor No");
                } else if ($scope.Flat.Area == 0) {
                    toastr.warning("Enter Area");
                } else if ($scope.Flat.AvgRate == 0) {
                    toastr.warning("Enter Avg Rate");
                } else if ($scope.Flat.BedRooms == 0) {
                    toastr.warning("Enter BedRooms");
                } else if ($scope.Flat.BathRooms == 0) {
                    toastr.warning("Enter BathRooms");
                } else if ($scope.Flat.FlatTypeId == "") {
                    toastr.warning("Select Flat Type");
                } else if ($scope.Flat.ContractType == "") {
                    toastr.warning("Select Contract Type");
                } else if ($scope.Flat.Title == "" && $scope.Flat.IsPublish == true) {
                    toastr.warning("Enter Flat Title");
                } else if ($scope.Flat.TitleAr == "" && $scope.Flat.IsPublish == true) {
                    toastr.warning("Enter Flat Title Arabic");
                } else if ($scope.Flat.Photo == "" && $scope.Flat.IsPublish == true) {
                    toastr.warning("Select Photo");
                } else if ($scope.Flat.RentalIncomeAccountId == "") {
                    toastr.warning("Select Rental Income Account");
                } else if ($scope.Flat.RentReceivableAccountId == "") {
                    toastr.warning("Select Rent Receivable Account");
                } else if ($scope.Flat.PenaltyAccountId == "") {
                    toastr.warning("Select Penalty Account");
                } else if ($scope.Flat.AdvanceRentAccountId == "") {
                    toastr.warning("Select Advance Rent Account");
                } else if ($scope.Flat.BankAccountId == "") {
                    toastr.warning("Select Bank Account");
                } else if ($scope.Flat.BankLoanAccountId == "") {
                    toastr.warning("Select Bank Loan Account");
                } else if ($scope.Flat.ProvisionAccountId == "") {
                    toastr.warning("Select Provision Account");
                } else if ($scope.Flat.RentalAdvanceReceivableAccountId == "") {
                    toastr.warning("Select Rental Advance Receivable Account");
                } else if ($scope.Flat.RentalAdvanceReceivableCloseAccountId == "") {
                    toastr.warning("Select Rental Advance Receivable Close Account");
                } else if ($scope.Flat.ParkingIncomeAccountId == "") {
                    toastr.warning("Select Parking Income Account");
                } else if ($scope.Flat.ParkingAdvanceAccountId == "") {
                    toastr.warning("Select Parking Advance Account");
                } else if ($scope.Flat.LandloardCommissionAccountId == "") {
                    toastr.warning("Select Landloard Commission Account");
                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.AddFlat($scope.Flat).then(function (response) {
                        if (response.data == "Success") {
                            $scope.Load = false;
                            toastr.success("Success");
                            $state.go("Flat");
                            $scope.init();
                        } else {
                            $scope.Load = false;
                            toastr.warning(response.data);
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        $.LoadingOverlay("hide");
                        toastr.error("Network Error");
                        $scope.Load = false;
                    });
                }
            }



            $scope.getParticulars = function () {

                $scope.BParticulars = {
                    Amount: null,
                    VatType: "Exclusive",
                    VATId: "",
                    ParticularsId: "",
                    CreditAccountId: "",
                    FlatId: $scope.Flat.Id
                }


                $scope.ViewVal = 2;

                $scope.BuildingParticulars = [];
                MainService.GetAllFlatParticulars($scope.Flat.Id).then(function (response) {
                    $scope.BuildingParticulars = response.data;
                });
            }

            $scope.addBuildingParticulars = function () {
                if ($scope.BParticulars.ParticularsId == "") {
                    toastr.warning("Select Particulars");
                } else if ($scope.BParticulars.CreditAccountId == "") {
                    toastr.warning("Select Credit Account");
                } else if ($scope.BParticulars.VATId == "") {
                    toastr.warning("Select Vat");
                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.AddFlatParticulars($scope.BParticulars).then(function (response) {
                        if (response.data) {
                            $scope.Load = false;
                            toastr.success($scope.SuccessLan);
                            $scope.getParticulars();
                        } else {
                            $scope.Load = false;
                            toastr.error($scope.NetworkErrorLan);
                        }
                        $.LoadingOverlay("hide");
                    }, function () {
                        $.LoadingOverlay("hide");
                        toastr.error($scope.NetworkErrorLan);
                        $scope.Load = false;
                    })

                }
            }

            $scope.editParticulars = function (data) {
                $scope.BParticulars = data;
            }

            $scope.selectedBPToDelete = {};
            $scope.deleteParticulars = function (data) {
                $scope.selectedBPToDelete = data;
                $('#deleteModalBP').modal('show');
            }

            $scope.deleteBPWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteFlatParticulars($scope.selectedBPToDelete.Id).then(function (response) {
                    if (response.data == true) {
                        $scope.Load = false;
                        toastr.success($scope.SuccessLan);
                        $('#deleteModalBP').modal('hide');
                        $scope.getParticulars();
                    } else {
                        $scope.Load = false;
                        toastr.warning($scope.CannotdeleteOperationsfoundLan);
                    }
                    $.LoadingOverlay("hide");
                }, function () {
                    $.LoadingOverlay("hide");
                    toastr.error($scope.NetworkErrorLan);
                    $scope.Load = false;
                })

            }



        }]);
